import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { HttpModule } from '@angular/http';

import { NodeGraphComponent } from './node-graph.component';
import { NodeGraphService } from './node-graph.service';

@NgModule({
  declarations: [
    NodeGraphComponent
  ],
  imports: [
    CommonModule,
    HttpModule
  ],
  providers: [NodeGraphService],
  bootstrap: [NodeGraphComponent],
})

export class NodeGraphModule { }



// WEBPACK FOOTER //
// /Users/sensorflow/Documents/legacy/kalinda/Dashboard/sensorflow-dashboard/src/app/location-status/node-graphs/node-graph.module.ts